import axios from 'axios';

// Tenant-facing feature entitlements (Workbooks / Vera / Sentinel).
// The axios interceptor handles auth headers; the gateway routes to backend.
const featureService = {
  // -> { workbooks: bool, vera: bool, sentinel: bool }
  getMyFeatures: async () => {
    const response = await axios.get('/api/v1.0/features/me');
    return response.data || {};
  },

  // ---- operator endpoints (SUPER_ADMIN) ----
  listFeatureFlags: async () => {
    const response = await axios.get('/api/operator/feature-flags');
    return response.data || [];
  },
  setDefault: async (feature, enabledByDefault) =>
    axios.put(`/api/operator/feature-flags/${feature}`, { enabledByDefault }),
  setOverride: async (feature, orgId, enabled) =>
    axios.post(`/api/operator/feature-flags/${feature}/tenants/${orgId}`, { enabled }),
  clearOverride: async (feature, orgId) =>
    axios.delete(`/api/operator/feature-flags/${feature}/tenants/${orgId}`),
};

export default featureService;
